// AdminDashboard.jsx
import React from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

export default function AdminDashboard() {
  const navigate = useNavigate();

  const tiles = [
    { title: "Support Tickets", desc: "View and respond to support requests.", path: "/admin/support" },
    { title: "Orders", desc: "Track vendor + customer orders and reconcile.", path: "/admin/orders" },
    { title: "Inventory", desc: "Check inventory counts and update SKUs.", path: "/admin/inventory" },
    { title: "SmartTags", desc: "Manage tags, activation codes, and batches.", path: "/admin/tags" },
    { title: "X Reply Drafts", desc: "Approve / reject replies before posting.", path: "/admin/x-replies" },
    { title: "X Reply Posts", desc: "Daily X post generator.", path: "/admin/x-posts" },
    { title: "Tag Batches", desc: "Generate QR CSV + SVG ZIP and email vendor.", path: "/admin/tag-batches" },

  ];

  return (
    <div className="admin-dashboard-wrapper">
      <Container className="admin-dashboard-shell">
        <div className="admin-dashboard-header">
          <div className="admin-dashboard-header-left">
            <div className="admin-dashboard-header-icon">🛠️</div>
            <div className="admin-dashboard-header-text">
              <div className="admin-dashboard-title">Admin Dashboard</div>
              <div className="admin-dashboard-subtitle">
                Quick access to Little Paws Place admin tools.
              </div>
            </div>
          </div>
        </div>

        <div className="admin-dashboard-body">
          <Row className="g-3">
            {tiles.map((t) => (
              <Col key={t.path} xs={12} md={6}>
                <Card className="admin-tile h-100">
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="admin-tile-title">{t.title}</Card.Title>
                    <Card.Text className="admin-tile-desc" style={{ flex: 1 }}>
                      {t.desc}
                    </Card.Text>

                    <Button className="lpp-pill-btn admin-tile-btn" onClick={() => navigate(t.path)}>
                      Open
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
}
